import { formatDate } from "@angular/common";
import {
  Component,
  ElementRef,
  Inject,
  Input,
  OnInit,
  Type,
  ViewChild,
} from "@angular/core";
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from "@angular/forms";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { MatSnackBar } from "@angular/material/snack-bar";
import { Router } from "@angular/router";
import { AdminService } from "../admin.service";

@Component({
  selector: "app-admin-edit-work-order",
  templateUrl: "./admin-edit-work-order.component.html",
  styleUrls: ["./admin-edit-work-order.component.css"],
})
export class AdminEditWorkOrderComponent implements OnInit {
  workorderForm: FormGroup;
  enabledetails: boolean = false;
  dropAutoComplete: any;
  pickupAutoComplete: any;
  pickupLat: any;
  pickupLong: any;
  dropLat: any;
  dropLong: any;
  id: any;
  selectTruckValue: any;
  truckList: any = [];
  loading: boolean = false;
  completeDropAddress: any;
  completePickUpAddress: any;
  pickup_long_name: any = "";
  pickup_short_name: any = "";
  drop_long_name: any = "";
  drop_short_name: any = "";
  pickup_postal_code: any;
  dropoff_postal_code: any;
  @ViewChild("pickUpLocationSearchField")
  pickUpLocation: ElementRef | any;
  @ViewChild("dropLocationSearchField")
  dropLocation!: ElementRef;
  @Input() min: any;
  minDate = new Date();
  @Input() max: any;
  maxDate = new Date();
  truckCategory: any = [];
  loadCategory: any;
  token: any;
  user_id: any;
  loadCategorySelectedindex: number;
  // loadCategorySelectedindex: any;
  loadSelectedCategory: any;
  materialDetails: any;
  otherValue: any;
  materialTypeSelected: boolean = false;
  editWOData: any = [];
  corporate_name: any = [];
  workorderArray: any;
  vehicleArray: any;
  unloadingQty: any;
  loadingQty: any;
  selectedWorkOrderQty: any;
  total_quantity: any;
  work_order_msg: any;
  dateFormat = "yyyy-MM-dd";
  language = "en";
  selectCatgValue: any;
  vehiclelists: any;
  truckArray: any;
  work_order_qty: any;
  workOrderQnty: any;
  selectedLoadedQuantity: any;
  perPage: any = 100;
  startPage: any = 1;
  searchLoadType: any = -1;
  page: any = 1;
  searchEmployeeName: any = -1;
  employeeStartPage: any = 1;
  employeeName: any = [];
  customerMobile = -1;
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,

    private formBuilder: FormBuilder,
    private matdialogref: MatDialogRef<AdminEditWorkOrderComponent>,
    private services: AdminService,
    private service: AdminService,
    private snackBar: MatSnackBar,
    private router: Router
  ) {
    this.maxDate.setDate(this.maxDate.getDate() + 0);    
  }

  ngOnInit(): void {
    this.editWOData = this.data;
    this.token = localStorage.getItem("adminToken");
    this.getLoadDetails();
    this.employeeGet(this.searchEmployeeName);
    this.GetCategory();
    this.workorderForm = this.formBuilder.group({
      from_complete_address: new FormControl(
        null,
        Validators.compose([Validators.required])
      ),
      to_complete_address: new FormControl(
        null,
        Validators.compose([Validators.required])
      ),
      pickup_date: [""],
      truck_category: ["", [Validators.required]],
      total_tons: ["", Validators.compose([Validators.required])],
      price_per_ton: ["", Validators.compose([Validators.required])],
      material_type: ["", Validators.compose([Validators.required])],

      username: ["", Validators.required],
      // mobile: [""],
      pickup_name: ["", [Validators.required]],
      address_line: ["", Validators.compose([Validators.required])],
      pickup_contact: ["", Validators.compose([Validators.required])],
      city: [
        "",
        [Validators.required, Validators.pattern("^[a-zA-Z][a-zA-Z\\s]+$")],
      ],

      dropoff_name: ["", [Validators.required]],
      gst: [""],
      state: ["", [Validators.pattern("^[a-zA-Z][a-zA-Z\\s]+$")]],
      pincode: ["", [Validators.required]],
      dropoff_contact: [
        "",
        Validators.compose([
          Validators.required,
          Validators.pattern("^[0-9]{4,10}$"),
        ]),
      ],
      pay_as_load_quantity: [""],
      entry_by: [""],
    });
    this.getCustomerList();
    this.workorderForm.patchValue(this.editWOData);
    if (
      this.editWOData?.price_per_ton !== undefined &&
      this.editWOData?.price_per_ton !== null &&
      this.editWOData?.price_per_ton !== ""
    ) {
      const price = Number(this.editWOData.price_per_ton);
      if (!isNaN(price)) {
        this.workorderForm.patchValue({
          price_per_ton: Number(price.toFixed(2)),
        });
      }
    }
    this.workorderForm.patchValue(this.editWOData.billing_address);
    this.workorderForm.patchValue(this.editWOData.material_type);
    this.workorderForm.patchValue(this.editWOData.load_type);
    this.workorderForm.patchValue({
      pay_as_load_quantity:
        this.editWOData?.pay_as_load_quantity || "loaded_quantity",
    });
    this.fetchDataFromBackend();
  }

  formatPricePerTon() {
    const val = this.workorderForm.get("price_per_ton")?.value;
    if (val !== null && val !== undefined && val !== "") {
      const num = Number(val);
      if (!isNaN(num)) {
        this.workorderForm.patchValue({
          price_per_ton: Number(num.toFixed(2)),
        });
      }
    }
  }

  fetchDataFromBackend() {
    // Patch values into the form
    this.patchFormValues();
  }

  patchFormValues() {
    // Patch material_type value from materialDetails into the form
    this.workorderForm.patchValue({
      material_type: this.editWOData.material_type, // Assuming you want to patch the first material type
    });
  }
  ngAfterViewInit(): void {
    var options = {
      componentRestrictions: { country: "in" },
    };
    this.pickupAutoComplete = new google.maps.places.Autocomplete(
      this.pickUpLocation.nativeElement,
      options
    );
    this.dropAutoComplete = new google.maps.places.Autocomplete(
      this.dropLocation.nativeElement,
      options
    );
  }
  onInputPickUpchange() {
    this.geoCodePickUp(this.workorderForm.value.pickup);
    this.checkLocations();
  }

  onDropChange() {
    this.geoCodeDrop(this.workorderForm.value.drop);
    this.checkLocations();
  }
  public get ProfileFormControl() {
    return this.workorderForm.controls;
  }
  public get contactFormControl() {
    return this.workorderForm.controls;
  }

  geoCodePickUp(address: any) {
    google.maps.event.addListener(
      this.pickupAutoComplete,
      "place_changed",
      () => {
        const place = this.pickupAutoComplete.getPlace();
        const geoCoder = new google.maps.Geocoder();
        geoCoder.geocode(
          {
            address: place.formatted_address,
          },
          (results: any, status) => {
            if (status == google.maps.GeocoderStatus.OK) {
              this.pickupLat = results[0].geometry.location.lat();
              this.pickupLong = results[0].geometry.location.lng();
              const latlong = new google.maps.LatLng(
                this.pickupLat,
                this.pickupLong
              );
              geoCoder.geocode({ location: latlong }, (result: any, status) => {
                this.completePickUpAddress = result[0];
                this.pickup_short_name = "";
                this.pickup_long_name = "";
                for (
                  let i = 0;
                  i < this.completePickUpAddress.address_components.length;
                  i++
                ) {
                  if (
                    this.completePickUpAddress.address_components[i].types[0] ==
                      "locality" &&
                    this.completePickUpAddress.address_components[i].types[1] ==
                      "political"
                  ) {
                    this.pickup_short_name =
                      this.completePickUpAddress.address_components[
                        i
                      ].long_name;
                  }
                  if (
                    this.completePickUpAddress.address_components[i].types[0] ==
                      "political" &&
                    this.completePickUpAddress.address_components[i].types[1] ==
                      "sublocality" &&
                    this.completePickUpAddress.address_components[i].types[2] ==
                      "sublocality_level_1"
                  ) {
                    this.pickup_long_name =
                      this.completePickUpAddress.address_components[
                        i
                      ].long_name;
                  }
                  if (
                    this.completePickUpAddress.address_components[i].types[0] ==
                    "postal_code"
                  ) {
                    this.pickup_postal_code = Number(
                      this.completePickUpAddress.address_components[i].long_name
                    );
                  }
                  if (this.pickup_short_name && this.pickup_long_name) {
                    this.workorderForm.controls["from_area_name"].setValue(
                      this.completePickUpAddress.formatted_address
                    );
                  }
                }
              });
            }
          }
        );
      }
    );
  }

  geoCodeDrop(address: any) {
    google.maps.event.addListener(
      this.dropAutoComplete,
      "place_changed",
      () => {
        const dropPlace = this.dropAutoComplete.getPlace();
        const geoCoder = new google.maps.Geocoder();
        geoCoder.geocode(
          {
            address: dropPlace.formatted_address,
          },
          (results: any, status) => {
            if (status == google.maps.GeocoderStatus.OK) {
              this.dropLat = results[0].geometry.location.lat();
              this.dropLong = results[0].geometry.location.lng();
              const latlong = new google.maps.LatLng(
                this.dropLat,
                this.dropLong
              );
              geoCoder.geocode({ location: latlong }, (result: any, status) => {
                this.completeDropAddress = result[0];
                this.drop_short_name = "";
                this.drop_short_name = "";
                for (
                  let i = 0;
                  i < this.completeDropAddress.address_components.length;
                  i++
                ) {
                  if (
                    this.completeDropAddress.address_components[i].types[0] ==
                      "locality" &&
                    this.completeDropAddress.address_components[i].types[1] ==
                      "political"
                  ) {
                    this.drop_short_name =
                      this.completeDropAddress.address_components[i].long_name;
                  }
                  if (
                    this.completeDropAddress.address_components[i].types[0] ==
                      "political" &&
                    this.completeDropAddress.address_components[i].types[1] ==
                      "sublocality" &&
                    this.completeDropAddress.address_components[i].types[2] ==
                      "sublocality_level_1"
                  ) {
                    this.drop_long_name =
                      this.completeDropAddress.address_components[i].long_name;
                  }
                  if (
                    this.completeDropAddress.address_components[i].types[0] ==
                    "postal_code"
                  ) {
                    this.dropoff_postal_code = Number(
                      this.completeDropAddress.address_components[i].long_name
                    );
                  }
                  if (this.drop_short_name && this.drop_long_name) {
                    this.workorderForm.controls["to_area_name"].setValue(
                      this.completeDropAddress.formatted_address
                    );
                  }
                }
              });
            }
          }
        );
      }
    );
  }

  checkLocations() {
    const pickup = this.workorderForm.value.from_area_name
      ?.toLowerCase()
      .trim();
    const drop = this.workorderForm.value.to_area_name?.toLowerCase().trim();
    if (pickup && drop && pickup === drop) {
      this.snackBar.open(
        "Pickup and Drop Off locations cannot be the same",
        "Fail",
        { duration: 5000 }
      );
    }
    return;
  }

  public GetCategory() {
    this.services
      .GetCategory(
        this.token,
        this.searchEmployeeName,
        this.perPage,
        this.startPage
      )
      .subscribe(
        (response: any) => {
          if (response.status === 200) {
            this.truckCategory = response.body.data;
          }
        },
        (error) => {
          if (error.error.message === "jwt malformed") {
            this.router.navigateByUrl("admin/login");
            window.localStorage.clear();
            this.matdialogref.close();
          }
          if (error.error.message === "jwt expired") {
            this.router.navigateByUrl("admin/login");
            window.localStorage.clear();
            this.matdialogref.close();
          }
          if (error.error.message === "invalid signature") {
            this.router.navigateByUrl("admin/login");
            window.localStorage.clear();
            this.matdialogref.close();
          }
          this.snackBar.open(error.error.message, "Fail", {
            duration: 5000,
          });
        }
      );
  }
  public gettruckCatg(item: any) {
    this.selectTruckValue = item.value;
    this.services.GetTypeTruck(this.selectTruckValue, this.token).subscribe(
      (response: any) => {
        if (response.status === 200) {
          this.truckList = response.body.data;
        }
      },
      (error) => {
        if (error.error.message === "jwt malformed") {
          this.router.navigateByUrl("admin/login");
          window.localStorage.clear();
          this.matdialogref.close();
        }
        if (error.error.message === "jwt expired") {
          this.router.navigateByUrl("admin/login");
          window.localStorage.clear();
          this.matdialogref.close();
        }
        if (error.error.message === "invalid signature") {
          this.router.navigateByUrl("admin/login");
          window.localStorage.clear();
          this.matdialogref.close();
        }
        this.snackBar.open(error.error.message, "Fail", {
          duration: 5000,
        });
      }
    );
  }
  getLoadDetails() {
    this.services
      .GetLoadDetails(this.token, this.searchLoadType, this.perPage, this.page)
      .subscribe(
        (response: any) => {
          if (response.status === 200) {
            this.loadCategory = response.body.data;
            this.materialDetails = "";
            this.loadCategory.find((ele: any) => {
              if (ele.load_category === this.editWOData.load_type) {
                this.loadCategorySelectedindex = 0;
              } else {
                this.loadCategorySelectedindex = 1;
              }
              return (ele = this.editWOData.load_type);
            });

            this.editWOData.load_type;
            this.materialDetails = this.loadCategory.find((ele: any) => {
              return ele.load_category === this.editWOData.load_type;
            });
          }
        },
        (error) => {
          if (error.error.message === "jwt malformed") {
            this.router.navigateByUrl("admin/login");
            window.localStorage.clear();
            this.matdialogref.close();
          }
          if (error.error.message === "jwt expired") {
            this.router.navigateByUrl("admin/login");
            window.localStorage.clear();
            this.matdialogref.close();
          }
          if (error.error.message === "invalid signature") {
            this.router.navigateByUrl("admin/login");
            window.localStorage.clear();
            this.matdialogref.close();
          }
          this.snackBar.open(error.error.message, "Fail", {
            duration: 5000,
          });
        }
      );
  }

  public loadCatChange(category: any, index: any) {
    // Check if the selected category is already active
    if (this.loadCategorySelectedindex === index) {
      return;
    }
    this.loadSelectedCategory = category;
    this.loadCategorySelectedindex = index;
    // Find the corresponding material details for the selected category
    this.materialDetails = this.loadCategory.find((ele: any) => {
      return ele.load_category === category;
    });

    if ((category === "Non-Commercial") != this.editWOData.load_type) {
      this.workorderForm.value.material_type = "";
      this.workorderForm.patchValue({ material_type: "" });
      if (this.materialDetails?.material_type == 0) {
        this.snackBar.open("Material type not found..", "Fail", {
          duration: 5000,
        });
      }
    } else {
      this.fetchDataFromBackend();
    }
    if ((category === "Commercial") != this.editWOData.load_type) {
      this.workorderForm.value.material_type = "";

      this.workorderForm.patchValue({ material_type: "" });
      if (this.materialDetails?.material_type == 0) {
        this.snackBar.open("Material type not found..", "Fail", {
          duration: 5000,
        });
      }
    } else {
      this.fetchDataFromBackend();
    }
  }

  selectLoadedQty(selectedValue: any) {
    this.selectedLoadedQuantity = selectedValue;
  }
  close() {
    this.matdialogref.close();
  }

  getCustomerList() {
    this.services
      .getUsersCustomers(
        this.token,
        this.perPage,
        this.startPage,
        this.customerMobile
      )
      .subscribe(
        (response: any) => {
          let customerdata: any;
          customerdata = response.body.data;
          for (var i = 0; i < customerdata.length; i++) {
            if (customerdata[i].user_type == "corporate") {
              this.corporate_name.push(customerdata[i]);
            }
            this.corporate_name.filter((ele: any) => {
              if (ele._id == this.data.user_id) {
                this.user_id = ele;
              }
            });
          }
        },
        (error) => {
          if (error.error.message === "jwt malformed") {
            this.router.navigateByUrl("admin/login");
            window.localStorage.clear();
            this.matdialogref.close();
          }
          if (error.error.message === "jwt expired") {
            this.router.navigateByUrl("admin/login");
            window.localStorage.clear();
            this.matdialogref.close();
          }
          if (error.error.message === "invalid signature") {
            this.router.navigateByUrl("admin/login");
            window.localStorage.clear();
            this.matdialogref.close();
          }
          this.snackBar.open(error.error.message, "Fail", {
            duration: 5000,
          });
        }
      );
  }

  employeeGet(item: any) {
    this.services
      .getUsersEmployees(
        this.token,
        this.searchEmployeeName,
        this.perPage,
        this.employeeStartPage
      )
      .subscribe(
        (response: any) => {
          if (response.status === 200) {
            this.employeeName = response.body.data;
          }
        },
        (error) => {
          if (error.error.message === "jwt malformed") {
            this.router.navigateByUrl("admin/login");
            window.localStorage.clear();
            this.matdialogref.close();
          }
          if (error.error.message === "jwt expired") {
            this.router.navigateByUrl("admin/login");
            window.localStorage.clear();
            this.matdialogref.close();
          }
          if (error.error.message === "invalid signature") {
            this.router.navigateByUrl("admin/login");
            window.localStorage.clear();
            this.matdialogref.close();
          }
          this.snackBar.open(error.error.message, "Fail", {
            duration: 5000,
          });
        }
      );
  }

  onEditSave(event: any) {
    const pickups = this.workorderForm.get("from_complete_address")?.value;
    const dropup = this.workorderForm.get("to_complete_address")?.value;
    if (pickups && dropup && pickups === dropup) {
      this.snackBar.open(
        "Pick-up and Drop-off locations should not be the same",
        "Fail",
        { duration: 5000 }
      );
      return;
    }
    if (this.workorderForm.invalid) {
      this.snackBar.open("Plesae fill all the mandatory fileds", "Fail", {
        duration: 5000,
      });
      return;
    }
    this.loading = true; // ✅ Disable button immediately
    (event.target as HTMLButtonElement).disabled = true; // ✅ Disable button instantly

    const workorderData = {
      from_complete_address:
        this.completePickUpAddress?.formatted_address ||
        this.workorderForm.value.from_complete_address ||
        this.data.from_complete_address,
      pickup_details: {
        ...(this.data?.pickup_details || {}),
        from_area_name:
          this.workorderForm.value.from_area_name ||
          this.data.pickup_details?.from_area_name,
        from_city_name:
          this.pickup_short_name || this.data.pickup_details?.from_city_name,
        from_lat:
          this.pickupLat != null && !isNaN(this.pickupLat)
            ? (Math.round(this.pickupLat * 10000) / 10000).toString()
            : this.data.pickup_details?.from_lat,
        from_long:
          this.pickupLong != null && !isNaN(this.pickupLong)
            ? (Math.round(this.pickupLong * 10000) / 10000).toString()
            : this.data.pickup_details?.from_long,
        from_pincode:
          this.pickup_postal_code || this.data.pickup_details?.from_pincode,
      },
      to_complete_address:
        this.completeDropAddress?.formatted_address ||
        this.workorderForm.value.to_complete_address ||
        this.data.to_complete_address,
      dropoff_details: {
        ...(this.data?.dropoff_details || {}),
        to_area_name:
          this.workorderForm.value.to_area_name ||
          this.data.dropoff_details?.to_area_name,
        to_city_name:
          this.drop_short_name || this.data.dropoff_details?.to_city_name,
        to_lat:
          this.dropLat != null && !isNaN(this.dropLat)
            ? (Math.round(this.dropLat * 10000) / 10000).toString()
            : this.data.dropoff_details?.to_lat,
        to_long:
          this.dropLong != null && !isNaN(this.dropLong)
            ? (Math.round(this.dropLong * 10000) / 10000).toString()
            : this.data.dropoff_details?.to_long,
        to_pincode:
          this.dropoff_postal_code || this.data.dropoff_details?.to_pincode,
      },
      pickup_date: this.workorderForm.value.pickup_date,
      truck_category: this.workorderForm.value.truck_category,
      total_tons: Number(this.workorderForm.value.total_tons),
      price_per_ton: Number(
        Number(this.workorderForm.value.price_per_ton).toFixed(2)
      ),
      load_type: this.loadSelectedCategory || this.editWOData.load_type,
      material_type: this.workorderForm.value.material_type,
      billing_address: {
        ...(this.data?.billing_address || {}),
        username: this.workorderForm.value.username,
        address_line: this.workorderForm.value.address_line,
        city: this.workorderForm.value.city,
        state: this.workorderForm.value.state,
        pincode: this.workorderForm.value.pincode,
        gst: this.workorderForm.value.gst,
      },
      pickup_contact: Number(this.workorderForm.value.pickup_contact),
      pickup_name: this.workorderForm.value.pickup_name,
      dropoff_name: this.workorderForm.value.dropoff_name,
      dropoff_contact: Number(this.workorderForm.value.dropoff_contact),
      pay_as_load_quantity:
        this.workorderForm.value.pay_as_load_quantity ||
        this.data?.pay_as_load_quantity ||
        "loaded_quantity",
      remaining_tons: this.data.remaining_tons,
    };
    if (workorderData.total_tons === 0) {
      this.snackBar.open("The Total tonnage cannot be zero", "Fail", {
        duration: 5000,
      });
      return;
    }
    if (workorderData.price_per_ton === 0) {
      this.snackBar.open("Price per ton cannot be zero", "Fail", {
        duration: 5000,
      });
      return;
    }
    if (workorderData.material_type == "") {
      this.snackBar.open("Please select material type", "Ok", {
        duration: 5000,
      });
      return;
    }
    this.id = localStorage.getItem("workOrderId");
    this.loading = true;
    this.service
      .updateWorkorder(workorderData, this.token, this.data._id)
      .subscribe(
        (response: any) => {
          if (
            (response.status == 201 && response.status == 200) ||
            response.body.data
          ) {
            this.matdialogref.close({ event: "Success" });
          }
          setTimeout(() => {
            this.loading = false; // ✅ Enable button after response
            (event.target as HTMLButtonElement).disabled = false; // ✅ Re-enable button
          }, 500);
        },
        (error) => {
          this.loading = false;
          if (error.error.message === "jwt malformed") {
            this.router.navigateByUrl("admin/login");
            window.localStorage.clear();
            this.matdialogref.close();
          }
          if (error.error.message === "jwt expired") {
            this.router.navigateByUrl("admin/login");
            window.localStorage.clear();
            this.matdialogref.close();
          }
          if (error.error.message === "invalid signature") {
            this.router.navigateByUrl("admin/login");
            window.localStorage.clear();
            this.matdialogref.close();
          }
          this.snackBar.open(error.error.message, "Fail", {
            duration: 5000,
          });
        }
      );
  }
  clearPickUpField() {
    this.workorderForm.controls["from_complete_address"].setValue("");
  }
  clearDropUpField() {
    this.workorderForm.controls["to_complete_address"].setValue("");
  }

  validateNumber(event: KeyboardEvent) {
    const input = String.fromCharCode(event.keyCode);
    if (!/[0-9]/.test(input)) {
      event.preventDefault();
    }
  }
}
